var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { apiCreateProffitSearchDeviceRegenerate } from '../../../../actions/ProffitSearchDeviceAction';
import { wrapNotifyError, wrapDispatch } from '../../../action';
import { useBoolState, usePromiseDoingCallback } from '../../useHook';
/**
 * Proffit Searchの端末再確認モーダルを制御するuse
 * @param initialModalState
 * @param dispatch
 * @param unmountRef
 * @returns {any}
 */
export const useSlideSearchRegenerateDeviceModal = (initialModalState, dispatch, unmountRef) => {
    const { boolState: isShowRegenerateModal, changeFalse: hideRegenerateModal, changeTrue: showRegenerateModal, } = useBoolState(initialModalState);
    const { boolState: isShowCompleteModal, changeFalse: hideCompleteModal, changeTrue: showCompleteModal, } = useBoolState(false);
    const regenerate = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            yield wrapDispatch(dispatch, apiCreateProffitSearchDeviceRegenerate());
            if (!unmountRef.current) {
                hideRegenerateModal();
                showCompleteModal();
            }
        }));
    }), [unmountRef, dispatch, hideRegenerateModal, showCompleteModal]);
    const [onClickRegenerate, loading] = usePromiseDoingCallback(regenerate, unmountRef);
    return {
        hideCompleteModal,
        hideRegenerateModal,
        isShowCompleteModal,
        isShowRegenerateModal,
        loading,
        onClickRegenerate,
        showRegenerateModal,
    };
};
export const useSlideSearchRegenerateDevice = {
    useSlideSearchRegenerateDeviceModal,
};
